import { getClientVersion } from "owa-config";

const CLIENT_VERSION_HEADER = "x-client-version";

type HeaderMap = Record<string, string | undefined>;

export default function addClientVersionHeader(headers: Headers | HeaderMap): void {
    const clientVersion = getClientVersion();
    if (!clientVersion) {
        return;
    }
    
    if (headers instanceof Headers) {
        if (!headers.has(CLIENT_VERSION_HEADER)) {
            headers.set(CLIENT_VERSION_HEADER, clientVersion);
        }
        return;
    }
    
    if (!headers[CLIENT_VERSION_HEADER]) {
        headers[CLIENT_VERSION_HEADER] = clientVersion;
    }
}
